export const roles = (state) => state?.entities?.role;
export const rolesList = (state) =>
  roles(state) ? Object.values(roles(state)) : [];
export const getRole = (state, id) => roles(state)?.[id];
